import Notification, { NotificationEntity } from 'src/firebase/db/Notifications';
import { OrderBreadEntity } from 'src/firebase/db/OrderBreads';

export const getNotifications = (shopId: string) => Notification.getNotifications(shopId);
export const hasNotifications = (shopId: string) => Notification.hasNotifications(shopId);
export const getReservation = (id: string) => Notification.getReservation(id);
export const getReservations = (payload: {
  shopId: string;
  isNotified?: boolean;
  isAdmin?: boolean;
}) => Notification.getReservations(payload);
export const getDayReservation = (payload: { id: string; shopId?: string; isAdmin?: boolean }) =>
  Notification.getDayReservation(payload);

export const getDayNotifications = (
  shopId: string,
  startDate: Date,
  endDate: Date,
  isReservation: boolean,
  noDetails?: boolean,
) => {
  return Notification.getDayNotifications(shopId, startDate, endDate, isReservation, noDetails);
};

export const getTemplatesNotifications = (templateIds: string[]) => {
  return Notification.getTemplatesNotifications(templateIds);
};

export const createNotification = (query: NotificationEntity) => Notification.create(query);

export const createReservation = (payload: {
  orderBread: OrderBreadEntity;
  notification: NotificationEntity;
}) => Notification.createReservation(payload);

export const updateReservation = (payload: {
  orderBread: OrderBreadEntity;
  notification: NotificationEntity;
}) => Notification.updateReservation(payload);

export const deleteReservation = (payload: string) => Notification.deleteReservation(payload);
export const cancelReservation = (payload: { id: string }) =>
  Notification.cancelReservation(payload);

export const removeOrderBreadFromNotification = (orderBreadId: string) =>
  Notification.removeOrderBread(orderBreadId);
